<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col col-md-10 col-lg-8">
        <div class="row">
          <div class="col">
            <h1 v-if="instructions.title" class="text-center">{{ instructions.title }}</h1>
            <div v-if="instructions.body" class="body" v-html="instructions.body"></div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="form-group col col-sm-3" v-for="response in instructions.responses" :key="response.value">
            <button type="button" class="btn btn-block text-capitalize" @click="$emit('response', response.value)">
              {{ response.text }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    instructions: {
      title: String,
      body: String,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/base.scss";

.body {
  @extend .p-3;
  @extend .mb-4;
  @extend .border;

  max-height: 500px;
  overflow-y: auto;
  background-color: white;
}
</style>
